<script setup>
import PageHeader from "../common/PageHeader.vue";
import studentImport from "../students/StudentImportComponent.vue";
import groupList from "../students/groupList.vue";
import studentList from "../students/studentList.vue";
import add1student from "../students/add1student.vue";
import groupCreator from "../students/groupCreator.vue";
import groupCardEditor from "../students/groupCardEditor.vue";
import api from "@/services/axios";
import { ref, onMounted } from "vue";

// Identifiant du groupe sélectionné
const selectedGroupId = ref(null);
const selectedGroupForEdit = ref(null);
const refreshKey = ref(0);

function refreshGroups() {
  groupRefreshFlag.value++;
  // Éviter les double appels - le flag refresh fera le travail
}

const groupRefreshFlag = ref(0);

// Liste des groupes
const groupListData = ref([]); // Déclarez groupListData

// Appeler la méthode pour rafraîchir la liste des groupes au montage
onMounted(() => {
  refreshGroupList(); // Charge les données des groupes à l'initialisation
});


// Rafraîchir la liste des groupes
async function refreshGroupList() {


  try {
    const response = await api.get(`/groups`);
    console.log("GROUPLIST :", response.data.groups)

    if (!Array.isArray(response.data.groups)) {
      console.error("Erreur: la réponse API ne contient pas un tableau", response.data);
      return;
    }

    groupListData.value = response.data.groups; // Prendre uniquement le tableau
    selectedGroupForEdit.value = null;  // Ferme l'éditeur après mise à jour

  } catch (error) {
    console.error("Error refreshing group list:", error);
    alert("Failed to refresh group list.");
  }
}


// Ouvrir l'éditeur de groupe
function showGroupCardEditor(group) {
  console.log("Données du groupe à éditer :", group); // Log pour debug
  selectedGroupForEdit.value = { ...group }; // Force la création d'un nouvel objet pour garantir la réactivité
}

// Filtrer par groupe
function handleGroupSelection(groupId) {
  console.log("📡 Groupe sélectionné dans le parent :", groupId);
  selectedGroupId.value = groupId;
}

function clearGroupFilter(deletedGroupId) {
  if (selectedGroupId.value === deletedGroupId) {
    selectedGroupId.value = null;
  }
}

const showImport = ref(false);
const showAdd1Student = ref(false);
const showGroupCreator = ref(false);

const toggleShowImport = () => {
  showImport.value = !showImport.value;
  showGroupCreator.value = false;
  showAdd1Student.value = false;
};

const toggleshowAdd1Student = () => {
  showImport.value = false;
  showGroupCreator.value = false;
  showAdd1Student.value = !showAdd1Student.value;
};

const toggleshowGroupCreator = () => {
  showImport.value = false;
  showAdd1Student.value = false;
  showGroupCreator.value = !showGroupCreator.value;
};

function onGroupCreated() {
  // refreshKey.value++;              // dit à TabulatorRemote de se recharger
  showGroupCreator.value = false;
  refreshGroups();
}


function refreshFromChild() {
  refreshKey.value++; // 🔁 force le reload de TabulatorRemote
}


</script>

<template>
  <div class="main tab">
    <PageHeader
      title="Group Manager"
      subtitle="Organize students into groups and manage memberships"
      icon="bi-people"
      color="green"
    >
      <template #actions>
        <button @click="toggleshowGroupCreator()" type="button" class="btn-action btn-group">
          <i class="bi bi-plus-circle"></i>
          <span>Create Group</span>
        </button>
        <button @click="toggleshowAdd1Student()" type="button" class="btn-action btn-student">
          <i class="bi bi-person-plus"></i>
          <span>Add Student</span>
        </button>
        <button @click="toggleShowImport()" type="button" class="btn-action btn-import">
          <i class="bi bi-upload"></i>
          <span>Import Students</span>
        </button>
      </template>
    </PageHeader>
    <groupCreator v-if="showGroupCreator" @group-created="onGroupCreated" />
    <add1student v-if="showAdd1Student" />
    <studentImport v-if="showImport" @group-list-updated="refreshGroups" />

    <!-- Liste des groupes -->


    <groupList :refresh-flag="groupRefreshFlag" @select-item="handleGroupSelection" @group-edit="showGroupCardEditor"
      @group-deleted="clearGroupFilter" @refresh-request="refreshGroups" />
    <hr />
    <groupCardEditor v-if="selectedGroupForEdit" :group="selectedGroupForEdit" @close="selectedGroupForEdit = null"
      @updated="refreshGroupList" />

    <!-- Liste des étudiants -->
    <studentList :filterGroupId="selectedGroupId" @reset-group="selectedGroupId = null"
      @refresh-group-list="refreshGroups" :refresh-group-options="groupRefreshFlag" />

  </div>
</template>



<style scoped>
.tab {
  border-left: 1px gainsboro solid;
  background-color: #F8F9FA;
  padding: 20px;
}

/* Boutons d'action modernes */
.btn-action {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-action i {
  font-size: 1rem;
}

.btn-group {
  background: linear-gradient(135deg, #388E3C 0%, #2E7D32 100%);
  box-shadow: 0 2px 8px rgba(56, 142, 60, 0.3);
}

.btn-group:hover {
  background: linear-gradient(135deg, #2E7D32 0%, #1B5E20 100%);
  box-shadow: 0 4px 12px rgba(56, 142, 60, 0.4);
  transform: translateY(-2px);
}

.btn-student {
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
}

.btn-student:hover {
  background: linear-gradient(135deg, #1565C0 0%, #0D47A1 100%);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.4);
  transform: translateY(-2px);
}

.btn-import {
  background: linear-gradient(135deg, #7B1FA2 0%, #6A1B9A 100%);
  box-shadow: 0 2px 8px rgba(123, 31, 162, 0.3);
}

.btn-import:hover {
  background: linear-gradient(135deg, #6A1B9A 0%, #4A148C 100%);
  box-shadow: 0 4px 12px rgba(123, 31, 162, 0.4);
  transform: translateY(-2px);
}

.btn-action:active {
  transform: translateY(0);
}

/* Responsive design */
@media (max-width: 768px) {
  .btn-action {
    font-size: 0.85rem;
    padding: 8px 14px;
  }
}

@media (max-width: 576px) {
  .btn-action {
    width: 100%;
    justify-content: center;
  }
}
</style>